import { snakeCase, varchar, text, timestamp } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { clientsTable } from './clients.table'

export const domainsTable = snakeCase.table('domains', {
    id: id('sac'),
    clientId: text()
        .notNull()
        .references(() => clientsTable.id, {
            onDelete: 'cascade',
            onUpdate: 'cascade',
        }),
    domain: varchar({ length: 253 }).notNull().unique(), // brac.net, brac.org
    activatedAt: timestamp({ withTimezone: true }).defaultNow(),
    suspendedAt: timestamp({ withTimezone: true }),
    ...timestamps,
})
